import React from 'react'

const Tab = ({ children }) => {
  return <div className="c-tab c-tab--item">{children}</div>
}

export default Tab
